import { AllContexts, AllEvents } from "./allEvents";
import { BaseEventEmitter } from "./baseEventEmitter";
import { globalEventBus, GlobalEventBus } from "./eventBus";
import { EventsWithContext } from "./types";

export class EventEmitter<
  Namespace extends string,
  Events extends Record<string, any>,
  Context = any,
> extends BaseEventEmitter<Events, Context> {
  private globalEventBus: GlobalEventBus;
  private namespace: Namespace;

  constructor(namespace: Namespace) {
    super();
    this.globalEventBus = globalEventBus;
    this.namespace = namespace;
  }

  emit<Key extends keyof Events>(
    type: Key,
    eventData: Events[Key],
    context?: Context,
    options = { skipGlobal: false }
  ): EventsWithContext<Events, Context>[Key] {
    const eventWithProcessedContext = super.emit(type, eventData, context);

    const namespacedType = `${this.namespace}.${String(type)}` as `${Namespace}.${Key & string}`;

    if (!options.skipGlobal) {
      this.globalEventBus.emit(
        namespacedType as any,
        eventWithProcessedContext.payload,
        eventWithProcessedContext.context as AllContexts
      );
    }

    return eventWithProcessedContext;
  }
}
